module.exports = {
  sidebar: [
    {
      label: "",
      routes: [
        {
          label: "Home",
          name: "home",
        },
        {
          label: "Disciplina",
          name: "disciplina",
        },
        {
          label: "Manifestazione",
          name: "manifestazione",
        },
        {
          label: "Fornitore",
          name: "fornitore",
        },
        {
          label: "Avvenimento",
          name: "avvenimento",
        },
        {
          label: "Nazione",
          name: "nazione",
        },
        {
          label: "Canale",
          name: "canale",
        },
        {
          label: "Stato",
          name: "stato",
        },
        {
          label: "Periodo",
          name: "periodo",
        },
        {
          label: "Scommessa",
          name: "descrizionescommessa",
        },
        {
          label: "Esito",
          name: "descrizioneesito",
        },
      ],
    },
    {
      label: "Mapping",
      routes: [
        {
          label: "Nazione",
          name: "mappingnazione",
        },
        {
          label: "Disciplina",
          name: "mappingdisciplina",
        },
        {
          label: "Manifestazione",
          name: "mappingmanifestazione",
        },
        {
          label: "Avvenimento",
          name: "mappingavvenimento",
        },
        {
          label: "Scommessa",
          name: "mappingscommessa",
        },
        {
          label: "Periodo",
          name: "mappingperiodo",
        },
      ],
    },
    {
      label: "Anagrafica",
      routes: [
        {
          label: "Utente",
          name: "utente",
        },
        {
          label: "Macchina Streaming",
          name: "macchinastreaming",
        },
      ],
    },
    {
      label: "Impostazioni",
      routes: [
        {
          label: "asseverazione evento",
          name: "impostazionievento",
        },
      ],
    },
  ],
  home: [
    {
      label: "",
      routes: [
        {
          label: "Disciplina",
          name: "disciplina",
          text: "Tutte le discipline dalla tabella 'sports'",
        },
        {
          label: "Manifestazione",
          name: "manifestazione",
          text: "Tutte le manifestazioni dalla tabella 'tournaments'",
        },
        {
          label: "Fornitore",
          name: "fornitore",
          text: "Tutti i fornitori dalla tabella 'providers'",
        },
        {
          label: "Avvenimento",
          name: "avvenimento",
          text: "Tutti gli avvenimenti dalla tabella 'events'",
        },
        {
          label: "Nazione",
          name: "nazione",
          text: "Tutte le nazioni dalla tabella 'countries'",
        },
        {
          label: "Canale",
          name: "canale",
          text: "Tutti i canali dalla tabella 'channels'",
        },
        {
          label: "Stato",
          name: "stato",
          text: "Tutti gli stati dalla tabella 'status_list'",
        },
        {
          label: "Periodo",
          name: "periodo",
          text: "Tutti i periodi dalla tabella 'periods'",
        },
        {
          label: "Scommessa",
          name: "descrizionescommessa",
          text:
            "Tutte le descrizioni delle scommesse dalla tabella 'market_list'",
        },
        {
          label: "Esito",
          name: "descrizioneesito",
          text: "Tutte le descrizioni degli esiti dalla tabella 'outcome_list'",
        },
      ],
    },
    {
      label: "Mapping",
      routes: [
        {
          label: "Nazione",
          name: "mappingnazione",
          text: "Mappatura delle nazioni tra ejoy e fornitori",
        },
        {
          label: "Disciplina",
          name: "mappingdisciplina",
          text: "Mappatura delle discipline tra ejoy e fornitori",
        },
        {
          label: "Manifestazione",
          name: "mappingmanifestazione",
          text: "Mappatura delle manifestazioni tra ejoy e fornitori",
        },
        {
          label: "Avvenimento",
          name: "mappingavvenimento",
          text: "Mappatura degli avvenimenti tra ejoy e fornitori",
        },
        {
          label: "Scommessa",
          name: "mappingscommessa",
          text: "Mappatura delle scommesse tra ejoy e fornitori",
        },
        {
          label: "Periodo",
          name: "mappingperiodo",
          text: "Mappatura dei periodi tra ejoy e fornitori",
        },
      ],
    },
    {
      label: "Anagrafica",
      routes: [
        {
          label: "Utente",
          name: "utente",
        },
        {
          label: "Macchina Streaming",
          name: "macchinastreaming",
        },
      ],
    },
    {
      label: "Impostazioni",
      routes: [
        {
          label: "asseverazione evento",
          name: "impostazionievento",
        },
      ],
    },
  ],
};
